import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Multi-Scanner panel art: two compact screener tables stacked with a divider
 * between them, so the card reads as more than one scan at once.
 */

type Table = {
  headerY: number
  /** [row top y, name bar width, rising?] */
  rows: [number, number, boolean][]
}

const TABLES: Table[] = [
  {
    headerY: 11,
    rows: [
      [19, 52, true],
      [27, 44, false],
      [35, 58, true],
    ],
  },
  {
    headerY: 58,
    rows: [
      [66, 48, false],
      [74, 56, true],
      [82, 42, true],
    ],
  },
]

export function MultiScannerArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {TABLES.map((table) => (
        <g key={table.headerY}>
          <rect
            x={12}
            y={table.headerY}
            width={16}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.25)"
          />
          <rect
            x={32}
            y={table.headerY}
            width={34}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.25)"
          />
          <rect
            x={126}
            y={table.headerY}
            width={22}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.25)"
          />
          {table.rows.map(([y, barWidth, rising]) => (
            <g key={y}>
              <rect
                x={12}
                y={y + 1}
                width={16}
                height={5}
                rx={2.5}
                fill="hsl(var(--foreground) / 0.22)"
              />
              <rect
                x={32}
                y={y + 1.5}
                width={barWidth}
                height={4}
                rx={2}
                fill="hsl(var(--foreground) / 0.12)"
              />
              <rect
                x={126}
                y={y + 1}
                width={22}
                height={5}
                rx={2.5}
                fill={rising ? 'hsl(var(--positive) / 0.35)' : 'hsl(var(--negative) / 0.35)'}
              />
            </g>
          ))}
        </g>
      ))}
      {/* Thin, well-spaced divider between the two scans. */}
      <path
        d="M12 50 H148"
        stroke="hsl(var(--muted-foreground) / 0.3)"
        strokeWidth="1"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
